export default function (...args)
{
	return {
		regex: /^(\d{13}|ISENTO)$/,
		filter: /[]/g,
	};
}

